module.exports = __webpack_public_path__ + "static/media/truck-travel.7bad6968.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/truck-travel.png
// module id = 607
// module chunks = 0